<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <!--<div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-card>
            <template #footer>
              <div>
                <b-row>
                  <b-col md="3" class="text-left"
                    >Line Items: {{ order.order_edit.OrderItems.length }}</b-col
                  >
                  <b-col md="3"
                    >Total Quantity: {{ order.order_edit.ItemCount }}
                  </b-col>
                  <b-col md="3"
                    >Total Points: {{ order.order_edit.PointTotal }}</b-col
                  >
                  <b-col md="3" class="text-right">
                    <em> {{ statusVerbiage }}</em>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #header>
              <b-row>
                <b-col md="2">
                  ORDER PLACED
                </b-col>
                <b-col md="2">TOTAL</b-col>
                <b-col v-if="order.order_edit.StatusCode < 4" md="6"
                  >SHIP TO</b-col
                >
                <b-col v-if="order.order_edit.StatusCode >= 4" md="6"
                  >SHIPPED TO</b-col
                >
                <b-col md="2" class="actionable"
                  >ORDER # {{ order.order_edit.OrderID }}
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <h5>{{ MyToLongDate(order.order_edit.DateOrdered) }}</h5>
                </b-col>
                <b-col md="2"
                  ><h5>{{ order.order_edit.PointTotal }} Points</h5></b-col
                >
                <b-col md="4">
                  <h5>
                    <span class="actionable">
                      {{ order.order_edit.ShipToName }}
                    </span>
                    <span id="spnShipTo">
                      <i class="fa fa-caret-down" />
                    </span>
                  </h5>
                  <b-tooltip
                    target="spnShipTo"
                    placement="bottom right"
                    style="padding-left: 10px;"
                  >
                    <div class="text-left" style="line-spacing: 1px;">
                      <h5>
                        <strong>{{ order.order_edit.ShipToName }}</strong
                        ><br />
                        {{ order.order_edit.ShipToAddress1 }}
                        {{ order.order_edit.ShipToAddress2 }}<br />

                        {{ order.order_edit.ShipToCity }}
                        {{ order.order_edit.ShipToState }}
                        {{ order.order_edit.ShipToZip }}<br />
                        {{ order.order_edit.ShipToCountry }}
                      </h5>
                    </div>
                  </b-tooltip>
                </b-col>
                <b-col md="4" class="text-right"> </b-col>
              </b-row>
            </template>

            <OrderItemHeader />
            <OrderItemRow
              v-for="oi in order.order_edit.OrderItems"
              :key="oi.OrderItemID"
              :orderitem_object="oi"
            />
          </b-card>
          <!-- <b-card border-variant="primary">
            <b-row class="mt-4">
              <b-col md="12">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Ship To</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToName.$error
                      }"
                      v-model="order.order_edit.ShipToName"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToName"
                      @input="$v.order.order_edit.ShipToName.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Address</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToAddress1.$error
                      }"
                      v-model="order.order_edit.ShipToAddress1"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToAddress1"
                      @input="$v.order.order_edit.ShipToAddress1.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Suite/Bldg</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      v-model="order.order_edit.ShipToAddress2"
                      autocomplete="off"
                      type="text"
                      id="ShipToAddress2"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >City</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToCity.$error
                      }"
                      v-model="order.order_edit.ShipToCity"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToCity"
                      @input="$v.order.order_edit.ShipToCity.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >State</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToState.$error
                      }"
                      v-model="order.order_edit.ShipToState"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToState"
                      @input="$v.order.order_edit.ShipToState.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Postal Code</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToZip.$error
                      }"
                      v-model="order.order_edit.ShipToZip"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToZip"
                      @input="$v.order.order_edit.ShipToZip.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth not_muted"
                        >Phone Number</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      class="not_muted"
                      :class="{
                        my_warning: $v.order.order_edit.ShipToPhone.$error
                      }"
                      v-model="order.order_edit.ShipToPhone"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="ShipToPhone"
                      v-mask="'(###) ###-####'"
                      @input="$v.order.order_edit.ShipToPhone.$touch()"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card> -->

          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              {{ cancelButtonVerbiage }}
            </b-button>
            <b-button
              v-if="order.order_edit.StatusCode <= -1"
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Order information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Order information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { required, email, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
import OrderItemHeader from "@/components/CustomRowComponents/OrderItemHeader.vue";
import OrderItemRow from "@/components/CustomRowComponents/OrderItemRow.vue";
//const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "OrderProfile",
  components: {
    CoolSelect,
    OrderItemHeader,
    OrderItemRow
  },
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false
    };
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/Order/Save/";
    this.$store.state.saveOp.localVariableName = "_o";
    this.$store.state.saveOp.localVariableObject = this.$store.state.order.order_edit;
    this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    this.$store.state.saveOp.localFieldToSet = "OrderID";
    this.$store.state.saveOp.localReturnObject = "SaveOrderResult";
  },
  methods: {
    //...mapActions("global", ["MyToLongDate"]),
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    }
  },
  computed: {
    ...mapState(["order", "product", "saveOp", "global"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    ...mapGetters("global", ["MyToLongDate"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    cancelButtonVerbiage() {
      return "Close Order Details";
      // if (this.$store.state.order.order_edit.StatusCode < 3) {
      //   return "Cancel";
      // } else {
      //   return "Close Order Detail";
      // }
    },
    statusVerbiage() {
      if (this.$store.state.order.order_edit.StatusCode < 4) {
        return (
          "Status: " +
          this.$store.state.order.order_edit.CurrentStatus.CurrentStatus
        );
      } else {
        return "Shipped on " + this.$store.state.order.order_edit.DateShipped;
      }
    }
  },

  validations: {
    order: {
      order_edit: {
        ShipToName: {
          required
        },
        ShipToAddress1: {
          required
        },
        ShipToCity: {
          required
        },
        ShipToState: {
          required
        },
        ShipToZip: {
          required
        },
        ShipToPhone: {
          required
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.not_muted {
  color: black;
  font-weight: 400;
  font-size: 16px;
}
</style>
